import React from 'react';
import { Modal } from 'react-bootstrap';
import HubspotForm from './HubspotForm';

function SupportModal(props) {

    const handleClose = () => props.onSubmitted(false);

    return (
        <Modal
            {...props}
            show={props.show}
            onHide={handleClose}
            animation={false}
            contentClassName="!rounded-[2px] max-w-[550px] w-full p-[var(--spacing08)]"
            centered
        >

            <Modal.Body className='p-0'>
                <Modal.Header className="support-modal-header p-0" closeButton>
                </Modal.Header>
                {props.show && <HubspotForm portalId="8615684" formId="9b21beb6-3570-432c-a305-534bfb48cdfe" userEmail={props.userEmail} workspaceId={props.workspaceId} />}
            </Modal.Body>
        </Modal>
    )
}

export default SupportModal
